<template>
  <div>
    <div class="custimer-inner">
      <div class="customer-box">
        <div class="animated fadeInDown slow">
          <div class="title">我们的客户</div>
        </div>
        <div class="logos animated fadeInUp slow">
          <ul>
            <li v-for="(item, index) in logos" :key="index">
              <img class="gray" :src="item.url" />
            </li>
          </ul>
          <div class="btn" style="margin-top: 10px">
            <a @click="goCustomer">客户案例</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      logos: [],
    }
  },
  mounted() {
    if (this.$store.state.app.device) {
      this.logos = new Array(42).fill(0).map((_, index) => ({
        url: 'https://cdnw2.acmcoder.com/release/www/version/static/images/logo2/' + (index + 1) + '.png',
      }))
    } else {
      this.logos = new Array(56).fill(0).map((_, index) => ({
        url: 'https://cdnw2.acmcoder.com/release/www/version/static/images/logo/' + (index + 1) + '.png',
      }))
    }
  },
  methods: {
    goCustomer() {
      this.$router.push('/customer')
    },
  },
}
</script>

<style lang="scss" scoped>
.custimer-inner {
  margin: auto;
  position: relative;
  top: -30px;
  margin-bottom: 20px;
}
.customer-box {
  padding: 20px 0px 0px;
  text-align: center;
  background: url('~@/static/images/home-five-bg.png') no-repeat center 50px;
  background-size: 70%;
}

.title {
  font-size: 36px;
  font-weight: 300;
}

.intro {
  font-size: 14px;
  padding: 20px 0px;
  color: #999;
  line-height: 25px;
}

.logos {
  width: 1200px;
  margin: 0px auto;
}
.logos ul {
  display: block;
  width: 1200px;
}
.logos ul li {
  width: 14%;
  display: inline-flex;
  cursor: pointer;
  padding: 0px 10px;
  text-align: center;
}
.logos ul li:hover {
  background: #fff;
  box-shadow: 0px 2px 12px 6px rgba(0, 0, 0, 0.2);
  .gray {
    padding: 0;
  }
}
.logos ul li:hover .gray {
  filter: none;
}
.logos ul li img {
  margin: 0px auto;
  max-height: 60px;
  max-width: 100%;
  padding: 6px;
}
.gray {
  -webkit-filter: grayscale(100%);
  -moz-filter: grayscale(100%);
  -ms-filter: grayscale(100%);
  -o-filter: grayscale(100%);

  filter: grayscale(100%);

  filter: gray;
}

@media screen and (max-width: 600px) {
  .custimer-inner {
    top: 10px;
    .title {
      font-size: 28px;
    }
    .logos {
      width: initial;
      ul {
        width: initial;
        li {
          width: 33%;
        }
      }
    }
  }
}
@media screen and (min-width: 600px) and (max-width: 1024px) {
  .custimer-inner {
    top: 10px;
    .title {
      font-size: 28px;
    }
    .logos {
      width: initial;
      ul {
        width: initial;
        li {
          width: 33%;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/customer.vue